import { TaskDto } from "src/app/web-api/web-api";
import {
  CstDateTimeService,
  DayOfWeek,
} from "src/app/services/cst-date-time.service";

export enum NumberTaskCollectionType {
  YearMonth = 1,
  CalendarWeek,
  Day,
}

export class NumberTaskCollection {
  private _tasksRef: TaskDto[];
  private _type: NumberTaskCollectionType;
  private _year: number;
  private _number: number;
  private _date: Date;

  public get Year(): number {
    return this._year;
  }
  public get Number(): number {
    return this._number;
  }
  public get Date(): Date {
    return this._date;
  }
  public get Type(): NumberTaskCollectionType {
    return this._type;
  }

  public get Display(): string {
    if (this._type === NumberTaskCollectionType.YearMonth) {
      const date = new Date(this._year, this._number - 1, 1);
      return (
        this.Year +
        " - " +
        date.toLocaleDateString(this._localeID, {
          month: "long",
        })
      );
    } else if (this._type === NumberTaskCollectionType.CalendarWeek) {
      return `${
        this.Year
      } - ${$localize`:@@CalendarWeek_ShortName:CW`} ${this.Number.toLocaleString(
        this._localeID,
        {
          minimumIntegerDigits: 2,
        }
      )}`;
    }
    return this._date.toLocaleDateString(this._localeID, {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  public get SubDisplay() {
    if (
      this._type === NumberTaskCollectionType.YearMonth ||
      this._type === NumberTaskCollectionType.Day
    ) {
      return null;
    }
    const start = this._dts.GetDateFromCalendarWeek({
      year: this.Year,
      week: this.Number,
    });
    const end = this._dts.GetDateFromCalendarWeek(
      {
        year: this.Year,
        week: this.Number,
      },
      DayOfWeek.Sunday
    );
    const dateOptions = {
      day: "2-digit",
      month: "2-digit",
    } as Intl.DateTimeFormatOptions;
    return `(${start.toLocaleDateString(
      this._localeID,
      dateOptions
    )} - ${end.toLocaleDateString(this._localeID, dateOptions)})`;
  }

  public get Tasks(): TaskDto[] {
    if (this._type === NumberTaskCollectionType.YearMonth) {
      return this._tasksRef.filter(
        (t) =>
          t.dateRanges &&
          t.dateRanges.periodOfAction &&
          t.dateRanges.periodOfAction.month === this._number &&
          t.dateRanges.periodOfAction.year === this._year
      );
    }
    if (this._type === NumberTaskCollectionType.CalendarWeek) {
      return this._tasksRef.filter(
        (t) =>
          t.dateRanges &&
          t.dateRanges.plannedWeek &&
          t.dateRanges.plannedWeek.week === this._number &&
          t.dateRanges.plannedWeek.year === this._year
      );
    }
    const result = this._tasksRef.filter(
      (t) =>
        t.dateRanges &&
        t.dateRanges.todoDate &&
        t.dateRanges.todoDate.getFullYear() === this._date.getFullYear() &&
        t.dateRanges.todoDate.getMonth() === this._date.getMonth() &&
        t.dateRanges.todoDate.getDate() === this._date.getDate()
    );
    return result;
  }

  constructor(
    private _dts: CstDateTimeService,
    private _localeID: string,
    tasksRef: TaskDto[],
    type: NumberTaskCollectionType,
    year?: number,
    num?: number,
    date?: Date
  ) {
    this._tasksRef = tasksRef;
    this._type = type;
    if (year && num) {
      this._year = year;
      this._number = num;
    } else if (date) {
      this._date = date;
      this._year = date.getFullYear();
      this._number = date.getMonth();
    }
  }

  public toJSON(): string {
    return JSON.stringify({
      year: this._year,
      number: this._number,
      date: this._date,
      type: this._type,
    });
  }
}
